var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 13.3333 12.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.282816 0.206648C0.405413 0.0995433 0.557046 0.0304698 0.718899 0.00799888C0.880751 -0.014472 1.0457 0.0106488 1.19328 0.0802443L12.9369 5.62698C13.0556 5.68315 13.1558 5.77147 13.226 5.88171C13.2961 5.99196 13.3333 6.11963 13.3333 6.24997C13.3333 6.3803 13.2961 6.50797 13.226 6.61822C13.1558 6.72847 13.0556 6.81678 12.9369 6.87296L1.19328 12.4197C1.05582 12.4845 0.903089 12.5109 0.751607 12.4959C0.600124 12.4809 0.455666 12.4251 0.33387 12.3346C0.212074 12.2441 0.117581 12.1223 0.0606194 11.9824C0.00365811 11.8425 -0.0136009 11.6898 0.0107108 11.5409L0.876224 6.24997L0.0107108 0.959054C-0.0117263 0.821073 0.00146034 0.679708 0.049041 0.548142C0.0966216 0.416575 0.177046 0.299093 0.282816 0.206648ZM1.72534 6.70141L0.933318 11.5421L12.1376 6.24997L0.933318 0.95785L1.72534 5.79852H6.19686C6.31767 5.79852 6.43354 5.84609 6.51897 5.93075C6.6044 6.01541 6.65239 6.13024 6.65239 6.24997C6.65239 6.3697 6.6044 6.48452 6.51897 6.56918C6.43354 6.65385 6.31767 6.70141 6.19686 6.70141H1.72534Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSupport);
export default __webpack_public_path__ + "static/media/profile_support.64078005f5d134ab133cfbd9cdb31892.svg";
export { ForwardRef as ReactComponent };